import { sortBy } from "lodash";

// Client specific ordered columns
export const CLIENT_SPECIFIC_ROUTE_GRID_ORDER = {
  FFE: [
    "violation",
    "dropYard",
    "routeName",
    "isReturnToTerminal",
    "status",
    "isTrapRoute",
    "dropYardName",
    "deliveryStopsCount",
    "totalPickupStops",
    "prosCount",
    "totalPickupBills",
    "totalPse",
    "totalPickupPallets",
    "frozenDeliveryPallets",
    "nonFrozenDeliveryPallets",
    "frozenPickupPallets",
    "nonFrozenPickupPallets",
    "totalWeight",
    "totalPickupWeight",
    "startTime",
    "driverReturnTime",
    "totalTime",
    "totalMiles",
    "tractor",
    "trailerName",
    "totalHu",
    "totalPickupHu",
    "aptProCount",
    "comment",
    "totalCalculatedPse",
    "lgProCount",
    "driverId",
    "loadedBills",
    "cubesCount",
    "priorityProCount",
    "specialNeedsProCount",
    "anchorPointName",
    "numServiceViolations",
    "anchorPointEmptyTime",
    "door",
  ],
};

/*
  check for client column order defined in CLIENT_SPECIFIC_ROUTE_GRID_ORDER,
  if order is defined -> return client specific order
  else -> return default order 
*/
export const getClientSpecificOrderedColumns = (defaultColumnOrder, columnConfig) => {
  const columnOrder = CLIENT_SPECIFIC_ROUTE_GRID_ORDER[columnConfig];
  if (!columnOrder) {
    return defaultColumnOrder;
  }
  return sortBy(defaultColumnOrder, (column) => {
    const colIndexLocation = columnOrder.indexOf(column.colId);
    return colIndexLocation !== -1 ? colIndexLocation : columnOrder.length;
  });
};
